import BaseRepository from '@/baseRepository/BaseRepository';
const resource = `/api/v1/conversations`;
export default { 
  getConversationList(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}`, {
      baseURL,
      headers,
      params
    });
  },
  getConversation(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/thread/flat`, {
      baseURL,
      headers,
      params
    });
  },
  getConversationById(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/${id}/thread`, {
      baseURL,
      headers,
      params,
    });
  },
  addConversation(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}`, body, {
      baseURL,
      headers,
      params,
    });
  },
  editConversation(id, body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.put(`${resource}/${id}/thread`, body, {
      baseURL,
      headers,
      params,
    });
  },
  deleteConversation(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.delete(`${resource}/${id}/thread`, {
      baseURL,
      headers,
      params,
    });
  },
};
